// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-detail-item__label[data-v-9907d8de]{font-weight:700}.product-detail-item__value[data-v-9907d8de]{color:var(--order-line-color,#333)}.product-detail-item__value--label[data-v-9907d8de]{display:inline-block;border-radius:50px;padding:0 10px;background:#e6f6ef;color:#36b079}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
